import api from './api';

export interface ParceiroFundador {
  id: number;
  nome: string;
  categoria: string;
  desconto: string | null;
  logo: string | null;
  descricao: string | null;
  endereco: string | null;
  telefone: string | null;
  website: string | null;
  destaque: 0 | 1;
  status: string;
  entidade_id: number | null;
  is_fundador: 0 | 1;
  cidade_fundador: string | null;
  data_fundador_inicio: string | null;
  data_fundador_expiracao: string | null;
  badge_visivel: 0 | 1;
  posicao_destaque: number | null;
  limite_marketing_cve: number | null;
  saldo_marketing_usado: number;
}

export interface FundadorStats {
  total: number;
  por_cidade: Array<{ cidade: string; n: number }>;
  expirando_30d: number;
  marketing_gasto: number;
  marketing_total: number;
}

export interface ParceiroActivityStats {
  entidade_id: number | null;
  clientes_pagali: number;
  num_transacoes: number;
  ticket_medio: number;
  total_vendido_cve: number;
  ultima_transacao: string | null;
  aviso?: string;
}

export interface FundadorPayload {
  is_fundador?: boolean;
  cidade_fundador?: string;
  data_fundador_inicio?: string;
  data_fundador_expiracao?: string;
  badge_visivel?: boolean;
  posicao_destaque?: number | null;
  limite_marketing_cve?: number | null;
  entidade_id?: number | null;
}

class MarketingParceirosService {
  async setup() { await api.post('/admin/marketing/parceiros-fundadores/setup'); }
  async stats(): Promise<FundadorStats> {
    const res = await api.get('/admin/marketing/parceiros-fundadores/stats');
    return res.data.data;
  }
  async list(cidade?: string): Promise<ParceiroFundador[]> {
    const qs = cidade ? `?cidade=${encodeURIComponent(cidade)}` : '';
    const res = await api.get(`/admin/marketing/parceiros-fundadores${qs}`);
    return res.data.data || [];
  }
  async activityStats(id: number): Promise<ParceiroActivityStats> {
    const res = await api.get(`/admin/marketing/parceiros-fundadores/${id}/stats`);
    return res.data.data;
  }
  async setFundador(id: number, payload: FundadorPayload) {
    await api.put(`/admin/marketing/parceiros-fundadores/${id}/fundador`, payload);
  }
  async renovar(id: number, meses: number) {
    await api.post(`/admin/marketing/parceiros-fundadores/${id}/renovar`, { meses });
  }
  async ajustarMarketing(id: number, valor: number) {
    await api.post(`/admin/marketing/parceiros-fundadores/${id}/marketing/ajustar`, { valor });
  }
}

export default new MarketingParceirosService();
